import initMainMenuSelected from './main-menu-selected';
import initToggleMenu from './main-menu-toggle';
import initMainMenuVisibility from './main-menu-visibility';

export default () => {
  initToggleMenu();
  initMainMenuVisibility();
  initMainMenuSelected();
};
